import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('drawingToolDropdown');

    return {
        CIRCLE: t('circle'),
        POLYGON: t('polygon')
    };
};

export default useTranslation;
